var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, unsafeCSS } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-sql';
// @ts-ignore
import prismTheme from 'prismjs/themes/prism-solarizedlight.css?inline';
let SqlCodeDisplayer = class SqlCodeDisplayer extends LitElement {
    constructor() {
        super(...arguments);
        this.code = '';
        this.highlighted = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateHighlightedCode();
    }
    updated(changed) {
        if (changed.has('code')) {
            this.scheduleHighlight();
        }
    }
    scheduleHighlight() {
        if (this.highlightTimeout)
            clearTimeout(this.highlightTimeout);
        this.highlightTimeout = window.setTimeout(() => this.updateHighlightedCode(), 50);
    }
    updateHighlightedCode() {
        this.highlighted = Prism.highlight(this.code || ' ', Prism.languages.sql, 'sql');
    }
    render() {
        return html `
      <basic-card>
        <pre><code class="language-sql" .innerHTML=${this.highlighted}></code></pre>
      </basic-card>
    `;
    }
};
SqlCodeDisplayer.styles = [css `
    :host {
      display: block;
      font-family: 'Fira Code', monospace;
    }
    pre[class*="language-"] {
      color: #586e75;
      background: none;
    }
    code[class*="language-"] {
      color: #586e75;
      background: none;
    }
  `, unsafeCSS(prismTheme)];
__decorate([
    property({ type: String })
], SqlCodeDisplayer.prototype, "code", void 0);
__decorate([
    state()
], SqlCodeDisplayer.prototype, "highlighted", void 0);
SqlCodeDisplayer = __decorate([
    customElement('sql-code-displayer')
], SqlCodeDisplayer);
export { SqlCodeDisplayer };
//# sourceMappingURL=SqlCodeDisplayer.js.map